// dependancies
import React from 'react'
import PropTypes from 'prop-types'

// styles
import CheckboxStyled from './Checkbox.styled'

const Checkbox = React.forwardRef((props, ref) => {
  const { id, name, change, value, required, error, checked, disabled } = props
  return (
    <CheckboxStyled
      className=""
      id={id}
      data-testid={id}
      type="checkbox"
      name={name}
      onChange={change}
      value={value}
      required={required}
      error={error}
      checked={checked}
      disabled={disabled}
      ref={ref}
    />
  )
})

// props validation
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  change: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  checked: PropTypes.bool,
  error: PropTypes.bool,
}

export default Checkbox
